import React, { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Download } from "lucide-react";
import { fmtDateTime } from "@/lib/helpers";

export default function FeedbackPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/feedback").then(setItems); }, []);
  return (
    <div className="p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Feedback demo</h1>
        <a href={`${API}/feedback.csv`} target="_blank" rel="noreferrer" data-testid="feedback-csv">
          <Button variant="outline"><Download className="w-4 h-4 mr-1.5" /> Esporta CSV</Button>
        </a>
      </div>
      <Card className="emmepi-card overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead>Data</TableHead>
              <TableHead>Profilo</TableHead>
              <TableHead>Categoria</TableHead>
              <TableHead>Schermata</TableHead>
              <TableHead>Descrizione</TableHead>
              <TableHead>Atteso</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map(f => (
              <TableRow key={f.id}>
                <TableCell className="text-xs">{fmtDateTime(f.created_at)}</TableCell>
                <TableCell>{f.profilo}</TableCell>
                <TableCell>{f.categoria}</TableCell>
                <TableCell>{f.schermata}{f.ticket_id && <div className="text-xs text-slate-500 font-mono">{f.ticket_id}</div>}</TableCell>
                <TableCell className="max-w-md whitespace-pre-wrap">{f.descrizione}</TableCell>
                <TableCell className="max-w-md whitespace-pre-wrap text-slate-600">{f.atteso}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-500">Nessun feedback ancora inserito. Usa "Segnala un problema" nelle schermate.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
